





















































































































































import {Vue, Component, Prop, Model} from 'vue-property-decorator';
import TextInput from '@/pro/components/common/input/TextInput.vue';

import {BoardsDetail} from 'supporter';

@Component({
  name: 'BoardDetail',
  components: {
    TextInput,
  },
})
export default class BoardDetail extends Vue {
  @Prop()
  @Model('boardDetail')
  boardDetail!: BoardsDetail;

  @Prop()
  hasBoard!: boolean;  

  @Prop({required: true, type: Number})
  boardIndex!: number;

  private addFirstCategory(): void {
    this.$emit('ADDF',this.boardDetail.categoryUsed);
  }

  private addCategory(): void {
    this.$emit('ADDC');
  }

  private delCategory(index: number): void {
    this.$emit('DELETEC', index);
  }

    // 등급 이름
  private onChangeName(name: string): void {
    this.$emit('changeDetailName', {name, type: 'info'});
  }


}
